var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.7 106.5",
    style: {
      enableBackground: "new 0 0 113.7 106.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_20096",
    transform: "translate(22499.464 20741.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    x: -22490,
    y: -20715,
    style: {
      fill: "none"
    },
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8861",
    style: {
      fill: "#DCEEFE"
    },
    d: "M-22400.6-20708.2c-17.6,4-13.3-40-41.5-31c-7.9,2.5-29.4-12.5-35.3,11.6 c-1.4,5.7-6.5,6.3-13.8,10c-7.3,3.6-9.2,13.5-7.9,22.2c-2.4,11.3,7,19.4,14.4,17.7c17.6-4,13.3,40,41.5,31 c7.9-2.5,29.3,12.5,35.3-11.6c1.4-5.7,6.5-6.3,13.8-10c7.3-3.6,9.2-13.5,7.9-22.2 C-22383.7-20701.7-22393.2-20709.8-22400.6-20708.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20102",
    transform: "translate(100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3203",
    transform: "translate(-22573 -20718)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 54,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    style: {
      fill: "none",
      stroke: "#44AC66",
      strokeWidth: 4
    },
    width: 50,
    height: 66
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3204",
    style: {
      fill: "#005BA9"
    },
    d: "M-22555-20720h19c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-19c-2.2,0-4-1.8-4-4 l0,0C-22559-20718.2-22557.2-20720-22555-20720z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_330",
    transform: "translate(-22550 -20727)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none"
    },
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeWidth: 2
    },
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20702.6,
    x2: -22541,
    y2: -20702.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20699.3,
    x2: -22541,
    y2: -20699.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20696,
    x2: -22546.2,
    y2: -20696
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -22543.0078 -20692)",
    style: {
      fill: "#9C9C9C",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 17
    }
  }, "?"), /*#__PURE__*/React.createElement("line", {
    id: "Line_174-2",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20687.9,
    x2: -22541,
    y2: -20687.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175-2",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20684.6,
    x2: -22541,
    y2: -20684.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176-2",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20681.3,
    x2: -22546.2,
    y2: -20681.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -22543.0078 -20677)",
    style: {
      fill: "#9C9C9C",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 17
    }
  }, "?"), /*#__PURE__*/React.createElement("line", {
    id: "Line_174-3",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20673.3,
    x2: -22541,
    y2: -20673.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175-3",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20670,
    x2: -22541,
    y2: -20670
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176-3",
    style: {
      fill: "none",
      stroke: "#9C9C9C"
    },
    x1: -22564.7,
    y1: -20666.7,
    x2: -22546.2,
    y2: -20666.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -22543.0078 -20662)",
    style: {
      fill: "#9C9C9C",
      fontFamily: "'Montserrat-Bold'",
      fontSize: 17
    }
  }, "?")), /*#__PURE__*/React.createElement("g", {
    id: "Group_20101",
    transform: "translate(-22481.309 -20709.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18098",
    transform: "translate(40.496 1.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8878",
    style: {
      fill: "#FFB27D"
    },
    d: "M24.6,14.2c0,0-0.2-0.5-0.3-0.7s-0.7-0.9-0.8-0.7s-0.5,1.1-0.3,1.4s0,0.8,1,1.1 L24.6,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8879",
    style: {
      fill: "#74BCFB"
    },
    d: "M36.1,11.3c0,0-5.3,4.4-7.4,4c-1.4-0.3-2.8-0.7-4.1-1.2l-0.5,1.3 c0,0,2.2,3,4.6,3.1c2.2,0,4.4-0.5,6.3-1.6L36.1,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8880",
    style: {
      fill: "#163560"
    },
    d: "M45.5,58.1c0,0-0.2,2.5-0.6,2.5c-0.1,0-2.4,0-2.4,0l-3,0c0-0.5,0.4-0.9,0.9-0.9 c1.2-0.2,2.3-0.9,2.9-2C43.7,56.6,45.5,58.1,45.5,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8881",
    style: {
      fill: "#2B478B"
    },
    d: "M45.7,58.3c-0.5,0.2-1.1,0.3-1.6,0.3c-0.5,0-1-0.1-1.5-0.2 c-0.3-1.8-0.6-3.6-1.1-5.4c-0.5-1.9-1.2-4.4-2.2-7.5c-1.6-4.6-2.8-9.3-3.8-14.1c0,0,0,0,0,0h0l8.7-3.8c0,0-1.1,11.8,0.3,16.4 c0.2,0.7,0.4,1.4,0.5,2.2C45.4,50.1,45.7,54.2,45.7,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8882",
    style: {
      fill: "#233862"
    },
    d: "M41.3,53c-0.5-1.9-1.2-4.4-2.2-7.5c-1.6-4.6-2.8-9.3-3.8-14.1c0,0,0,0,0,0l8.7-3.8 c0,0-1.1,11.8,0.3,16.4C44.5,44.5,41.3,53,41.3,53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8883",
    style: {
      fill: "#163560"
    },
    d: "M38.7,58.1c0,0-0.2,2.5-0.6,2.5c-0.1,0-2.4,0-2.4,0l-3,0c0-0.5,0.4-0.9,0.9-0.9 c1.2-0.2,2.3-0.9,2.9-2C37,56.6,38.7,58.1,38.7,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    style: {
      fill: "#2B478B"
    },
    d: "M33.8,27.8c0,5.7,0.4,11.4,1.2,17.1c1.3,9.4,0.9,13.4,0.9,13.4 c0.4,0.1,0.8,0.2,1.3,0.3c0.6,0,1.3,0,1.9-0.2c0,0,1.9-9.4,1.4-14.1S43,28.1,43,28.1L33.8,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8885",
    style: {
      fill: "#FFB27D"
    },
    d: "M39.9,9.9L38.2,11l-2.4-0.5c0-0.2,0.2-1,0.3-1.8c0,0,0-0.1,0-0.1 c0.1-0.6,0.2-1.2,0.2-1.2l2.3-1l0.9-0.4c0,0-0.1,0.7-0.1,0.8C39.4,7.9,39.5,8.9,39.9,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    style: {
      fill: "#96CDFC"
    },
    d: "M33.3,28.1c0,4,0.3,13.5,0.5,13.7c2.1,2,11.4-0.6,11.9-2.8s-1.9-28.7-5.5-29.8 c-0.7-0.2-4.7,1.1-4.7,1.1c-0.4,1.2-0.8,2.5-1,3.7c-0.2,0.8-0.6,6.3-0.9,10c-0.1,1-0.1,1.8-0.2,2.4 C33.3,26.7,33.3,27.3,33.3,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8887",
    style: {
      fill: "#FCA56B"
    },
    d: "M39.3,6.9c-0.5,0.9-2.4,1.6-3.2,1.9c0,0,0-0.1,0-0.1c0.1-0.6,0.2-1.2,0.2-1.2 l2.3-1C39.2,6.4,39.5,6.5,39.3,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8888",
    style: {
      fill: "#FFB27D"
    },
    d: "M35.5,7.3c0,0,3.7,1.1,4.4-1.2s1.6-3.7-0.7-4.5s-3-0.1-3.5,0.6S34.6,7,35.5,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8889",
    style: {
      fill: "#163560"
    },
    d: "M35.9,2c0,0,0.2,2.7,0.8,2.6s1.1-0.2,1,0.6s-0.8,1.7,0.9,1.9s4.2-4.3,3.7-5.1 C40.8-0.4,33.9-0.9,35.9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8890",
    style: {
      fill: "#95B3EF"
    },
    d: "M36.4,9.3c1-0.5,2-0.8,3.1-1.1c0.3,0.1,0.7,1.1,0.7,1.1l-4.7,1.1 C35.7,9.9,36,9.5,36.4,9.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18096",
    transform: "translate(1.28 -2.195) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8891",
    style: {
      fill: "#1F4D84"
    },
    d: "M18.6,20.7l14.2,15.1c0.3,0.3,0.7,0.3,1,0l0.9-0.9c0.3-0.3,0.3-0.7,0-1L20.6,18.8 c-0.3-0.3-0.7-0.3-1,0l-0.9,0.9C18.3,20,18.3,20.4,18.6,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    style: {
      fill: "#163560"
    },
    d: "M26.6,29.2l6.2,6.6c0.3,0.3,0.7,0.3,1,0l0.9-0.9c0.3-0.3,0.3-0.7,0-1l-6.2-6.6 L26.6,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    style: {
      fill: "#163560"
    },
    d: "M3.2,19.9c4.5,4.8,12,5,16.7,0.5c4.8-4.5,5-12,0.5-16.7C16-1,8.5-1.3,3.7,3.2 C3.7,3.3,3.6,3.3,3.5,3.4C-1.1,7.9-1.2,15.2,3.2,19.9z M4.8,4.4c4.1-3.9,10.5-3.7,14.4,0.4c3.9,4.1,3.7,10.5-0.4,14.4 c-4.1,3.9-10.5,3.7-14.4-0.4c0,0,0,0,0,0C0.6,14.7,0.7,8.3,4.8,4.4C4.8,4.4,4.8,4.4,4.8,4.4L4.8,4.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18095",
    transform: "translate(1.644 1.644)",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    style: {
      fill: "#B3CFF9"
    },
    d: "M2.8,17.2c3.9,4.1,10.3,4.3,14.4,0.4c4.1-3.9,4.3-10.3,0.4-14.4 C13.7-0.9,7.3-1.1,3.2,2.8c0,0,0,0,0,0C-0.9,6.6-1.1,13,2.8,17.2C2.7,17.1,2.7,17.1,2.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    style: {
      fill: "#D2E4FF"
    },
    d: "M2.8,17.2c1.4,1.5,3.1,2.5,5.1,2.9c5.5-1,9.3-6.2,8.3-11.8 c-0.7-4-3.7-7.2-7.7-8.2c-5.5,1-9.2,6.2-8.3,11.8C0.5,13.9,1.4,15.7,2.8,17.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    style: {
      fill: "#74BCFB"
    },
    d: "M33.3,28.1c8.8-6,8.1-14.1,8.1-14.1c-3.7,2.4-6.5,5.9-7.9,10 c-0.1,1-0.1,1.8-0.2,2.4C33.3,26.7,33.3,27.3,33.3,28.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18097",
    transform: "translate(23.146 10.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8897",
    style: {
      fill: "#FFB27D"
    },
    d: "M2.4,14.8c-0.4-0.1-0.8-0.3-1.1-0.7c0,0-0.2,0,0,0.5c0,0,0.1,0.2,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.4,0-0.9,0-1.3,0C0,15.1,0,15.3,0,15.4c0,0.2,0,0.4,0.2,0.6c0.3,0.3,0.7,0.4,1.1,0.5 c0.5,0.1,1.1,0,1.6-0.2L3.4,16l-0.2-1l-0.1,0C2.9,15.1,2.6,14.9,2.4,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8898",
    style: {
      fill: "#96CDFC"
    },
    d: "M15.6,0c0,0,7.5,1.4-2.2,12.2c-1.5,1.7-9.9,4-9.9,4s-0.8-0.7-0.4-1.3 c0,0,5.8-4.2,7-4.8c0.6-0.3,2.2-6.7,3.1-8.2C13.8,1,14.6,0.3,15.6,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8899",
    style: {
      fill: "#FFB27D"
    },
    d: "M24.4,14.3c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.4-0.3-0.8-0.5-1.1 c-0.1-0.1-0.2,0-0.2,0.2c0,0.2,0,0.3,0.1,0.5c0.1,0.3,0.1,0.6,0.2,0.9C23.8,14.6,24.4,14.3,24.4,14.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    style: {
      fill: "#96CDFC"
    },
    d: "M14.4,9.4c0,0,3.2,0.5,4,2.1s3.8,27.7,3.8,27.7c-1.7,0.7-3.6,1-5.4,0.9 C12.4,39.9,14.4,9.4,14.4,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    style: {
      fill: "#1A2D4C"
    },
    d: "M19.2,60.8c0,0.4,0.1,0.8,0.3,1.1h8c-0.1-0.2-0.4-0.6-1.2-0.7 c-1.2-0.1-2.3-0.6-3.3-1.3c-0.3-0.3-0.5-0.6-0.6-1c-0.4-1.4-3.1,0.4-3.1,0.4C19.2,59.8,19.2,60.3,19.2,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    style: {
      fill: "#1A2D4C"
    },
    d: "M7,60.8c0,0.4,0.1,0.8,0.3,1.1h8c-0.1-0.2-0.4-0.6-1.2-0.7 c-1.2-0.1-2.3-0.6-3.3-1.3c-0.3-0.3-0.5-0.6-0.6-1c-0.4-1.4-3.1,0.4-3.1,0.4C7,59.8,7,60.3,7,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8937",
    style: {
      fill: "#233862"
    },
    d: "M22.7,60.1c-0.9,0.2-2.6,1-3.7,0.6c-0.7-0.2-4.6-9.8-4.9-14.1 c0-0.4-0.1-0.8-0.2-1.3c-0.2-1.1-0.6-2.6-1.1-4.2c-1.3-4.4-3-9.9-2.9-11.7c0.1-2.7,9.7-0.6,9.7-0.6c0.5,1.8,0.7,3.6,0.8,5.5 c0.3,6.5,1,17.4,2.9,24.9C23.3,59.7,23,60,22.7,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8938",
    style: {
      fill: "#2B478B"
    },
    d: "M16,29.5l-4.2,30.8c-1.6,0.4-3.3,0.5-5,0.4c0,0-1.3-16.5-1.2-20.5 S4.5,29.4,5.9,28.7S16,29.5,16,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8939",
    style: {
      fill: "#FFFFFF"
    },
    d: "M5.2,10.8c0,0,5.3-2.9,9.2-1.4c0.7,0.4,1.3,0.8,1.8,1.4c1.4,1.3,4.1,21.7,4.1,21.7 s-7.7,2.2-15.1-0.7L5.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8940",
    style: {
      fill: "#96CDFC"
    },
    d: "M14.7,9.3c0,0,4.9,1.4,5.6,3.4c1.1,3.3,1.9,6.7,2.6,10.1c0,1-3.1,1.3-3.8-0.4 c-0.6-1.4-2.4-5.6-3.4-8.3L14.7,9.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18108",
    transform: "translate(7.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8941",
    style: {
      fill: "#FFB27D"
    },
    d: "M6.5,10.8c-1.4,0.2-2.9-0.1-4.2-0.7c0.4-0.8,0.7-1.7,0.9-2.7c0,0,0-0.1,0-0.1 c0-0.2,0-0.4,0-0.6h3c0,0,0.8,0.3,0.8,0.5c0,0.1,0,0.2,0,0.3c0,0.3,0,0.6,0,0.8c0,0.4,0.1,0.7,0.2,1.1c0.2,0.5-0.1,1.1-0.6,1.3 C6.7,10.7,6.6,10.8,6.5,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8942",
    style: {
      fill: "#E2915A"
    },
    d: "M7.2,8.4c-1.4,0.3-2.8-0.1-4-1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0.1,0 c1.3-0.2,2.6-0.1,3.9,0.3C7.2,7.9,7.2,8.1,7.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8943",
    style: {
      fill: "#FFB27D"
    },
    d: "M2.5,6.3C2.9,8.1,5.8,8.1,7,8c0.3,0,0.6-0.1,0.6-0.1C8,7.8,8.2,7.3,8.3,6.6 C8.5,5.3,8.4,4,8,2.7C7.6,2,6.8,1.1,3.9,1.7S2,3.9,2.5,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8944",
    style: {
      fill: "#233862"
    },
    d: "M8.1,1.7c-0.6-0.6-1.2-1-2-1.4c-1.2-0.4-2.5-0.4-3.7,0C0,1.2-0.6,2.8,0.6,5.1 C2,7.6,3.2,7.4,3.2,7.4S2.9,7.2,3,6.4c0,0,0-0.1,0-0.1C3,6.1,2.9,6,2.8,5.9C2.5,5.7,2.3,5,2.6,4.8c0.3-0.2,0.7,0,0.8,0.3 c0.1,0.2,0.3,0.2,0.5,0.1c0.7-0.4,0.3-1.2,1-1.7S7,3.4,8.1,3.1C9.5,2.6,8.4,2,8.1,1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8945",
    style: {
      fill: "#96CDFC"
    },
    d: "M15.4,41.1c-2.5,0.1-4.9,0-7.4-0.3c-0.7-0.1-3.7-0.4-4.3-0.6 c-0.1,0,0.2-6,0.5-12.2c0-0.6,0.1-1.3,0.1-1.9c0-0.3,0-0.5,0-0.8c0.3-5.5,0.5-10.4,0.6-10.7c0.1-0.6,0.2-1.1,0.4-1.6 c0.2-1.1,0.9-2,1.8-2.6c0.1-0.1,0.9-0.4,1.6-0.7c0.6-0.2,1.1-0.5,1.1-0.5l0,0c0.4,0.3,0.6,0.7,0.8,1.2c0.6,1.4,1.1,2.8,1.5,4.2 c0,0,0,0,0,0l0,0c0.3,0.9,0.4,1.5,0.5,1.7c0.1,0.3,0.2,0.9,0.3,1.8c0.2,1.1,0.4,2.7,0.6,4.5c0,0.2,0,0.4,0.1,0.6 c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0,0.2c0.1,0.7,0.2,1.4,0.3,2.2c0.1,0.6,1.2,1,1.2,1.7c0,0.4,0.1,3.7,0.2,4.8 C15.5,33.5,15.5,40.8,15.4,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8946",
    style: {
      fill: "#74BCFB"
    },
    d: "M7.6,16.9c0,0-0.2,5.5,4.7,6.2s1.6,0.8,1.6,0.8s-9.2-0.3-9.4-0.5 S7.6,16.9,7.6,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8947",
    style: {
      fill: "#74BCFB"
    },
    d: "M11.7,25.4c0,0-0.1,0.1-0.3,0.2h0c-2,1-4,1.8-6.2,2.2C4.9,27.9,4.5,28,4.2,28 c0-0.6,0.1-1.3,0.1-1.9c-0.4,0-0.8-0.1-1.2-0.1c0-0.1,0-0.2,0-0.3c0.4-0.1,0.8-0.3,1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3 c1.3-0.4,2.3-0.7,2.3-0.7l3.9,1.1L11.7,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8948",
    style: {
      fill: "#96CDFC"
    },
    d: "M12.8,25.3c0,0-0.5,0.1-1.3,0.2h0c-2,0.4-4.1,0.6-6.2,0.6c-0.3,0-0.7,0-1,0 c-0.4,0-0.8-0.1-1.2-0.1c-0.7-0.1-1.4-0.4-1.9-0.8C-2.2,22.4,2.9,12.1,4,11.1C5.2,10,7.5,9.6,8.8,9.4l0.2,0 c0.4,0,0.7-0.1,0.7-0.1l0,0c0,0-0.1,0.3-0.3,0.7c-0.1,0.2-0.1,0.4-0.2,0.6c-0.8,2.2-2.3,6.4-2.9,8.8C6.1,20,6,20.6,6,21.2 c0.3,0.8,2.9,1.2,4.6,1.4c0.7,0.1,1.2,0.1,1.4,0.1h0l0.1,0.3l0.2,0.8l0.2,0.8L12.8,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8949",
    style: {
      fill: "#2DAB6C"
    },
    d: "M22,30.3l-11.4-0.4l2.3-12l11.4,0.4L22,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    style: {
      fill: "#FFB27D"
    },
    d: "M12,22.7c0,0,2.2-0.1,2.3,0.3c0.3,1-1.9,1.9-2.6,1.8S11.5,22.6,12,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8951",
    style: {
      fill: "#FFB27D"
    },
    d: "M23.7,20.7c0,0-2.1-0.6-2.3-0.2c-0.5,0.9,1.3,2.2,2,2.3S24.2,20.7,23.7,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8952",
    style: {
      fill: "#74BCFB"
    },
    d: "M9.9,8.8C9.4,8.8,8.8,9.1,8.4,9.5c0,0,3.6,5.3,3.6,5.3S10.8,9.4,9.9,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8953",
    style: {
      fill: "#74BCFB"
    },
    d: "M14.3,8.8c0.4,0.2,0.8,0.5,1,0.9l0.4,4.5c0,0-0.9-3.3-1.3-4.8 C14.3,9.2,14.3,9,14.3,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8954",
    style: {
      fill: "#C65447"
    },
    d: "M16.7,18c0,0,0.1-0.3,0.6-0.3s3.4,0.2,3.4,0.2s0.6,0,0.5,0.3L16.7,18z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/Faq.0901d2bebaf007b9f1c6ce065373e3c4.svg";
export { ForwardRef as ReactComponent };